import React from 'react';
import t from './translations';
import { tradeSiteEnabled } from '../utils/toggles';

export const navBarLinksPreLogin = [
  {
    title: 'Home',
    href: '/'
  },
  {
    title: (<span>About{' '}<b>Ignite</b></span>),
    href: '/about-ignite'
  },
  {
    title: 'My Store',
    href: '/store-summary',
  },
  {
    title: 'Products',
    href: '/products'
  },
  {
    title: 'Contact Us',
    href: '/contact'
  }
];

export const navBarLinks = [
  {
    title: 'Home',
    href: '/'
  },
  {
    title: (<span>About{' '}<b>Ignite</b></span>),
    href: '/about-ignite',
    permissions: {
      action: 'view',
      subjectClass: 'web_app_view_articles',
    },
  },
  {
    title: 'My Store',
    children: [
      {
        title: 'Store Summary',
        href: '/store-summary'
      },
      {
        title: 'My Staff',
        href: '/my-staff',
        permissions: {
          action: 'handle',
          subjectClass: 'staff',
        }
      }
    ]
  },
  {
    title: 'Products',
    href: '/products',
    permissions: {
      action: 'view',
      subjectClass: 'web_app_products_page',
    }
  },
  {
    title: 'Rewards',
    permissions: {
      action: 'view,handle',
      subjectClass: 'objective_info,objective_performance,staff_rewards',
    },
    children: [
      {
        title: 'How to earn',
        href: '/how-to-earn',
        permissions: {
          action: 'view',
          subjectClass: 'objective_info,objective_performance',
        }
      },
      {
        title: 'Store Performances',
        href: '/store-performances',
        permissions: {
          action: 'view',
          subjectClass: 'objective_info,objective_performance',
        },
      },
      {
        title: 'Sell it uploader',
        href: '/submissions',
        permissions: {
          action: 'handle',
          subjectClass: 'sell_it_uploader',
        }
      },
      {
        title: t('staffRewards'),
        href: '/staff-rewards',
        permissions: {
          action: 'handle',
          subjectClass: 'staff_rewards',
        },
      },
      {
        title: 'Personal Rewards',
        href: '/personal-rewards',
        permissions: {
          action: 'index',
          subjectClass: 'personal_rewards',
        },
        hidePseudo: true,
      },
    ]
  },
  {
    title: 'Contact Us',
    href: '/contact-us'
  }
];

export const navBarLinksReps = [
  {
    title: 'Home',
    href: '/team'
  },
  {
    title: (<span>About{' '}<b>Ignite</b></span>),
    href: '/team/about-ignite',
    permissions: {
      action: 'view',
      subjectClass: 'article_info'
    }
  },
  {
    title: 'Stores',
    children: [
      {
        title: 'List view',
        href: '/team/stores/list',
      },
      /* {
        title: 'Map view',
        href: '/team/stores/map',
      }, */
    ],
    permissions: {
      action: 'view',
      subjectClass: 'store_info',
    }
  },
  {
    title: 'Submissions',
    href: '/team/submissions',
    permissions: {
      action: 'handle',
      subjectClass: 'Submission',
    },
  },
  {
    title: 'Latest News',
    children: [
      {
        title: 'RDR News',
        href: '/team/latest-news/rdr'
      },
      {
        title: 'Retailer News',
        href: '/team/latest-news/retailer'
      },
    ],
    permissions: {
      action: 'view',
      subjectClass: 'article_info',
    }
  },
  {
    title: 'Contact Us',
    href: '/team/contact-us'
  },
];

export const navBarLinksAdmin = [
  {
    title: 'Outlets',
    permissions: {
      action: 'manage',
      subjectClass: 'Outlet',
    },
    children: [
      {
        title: 'Outlets',
        href: '/admin/outlets',
        permissions: {
          action: 'manage',
          subjectClass: 'Outlet',
        }
      },
      {
        title: 'Delink',
        href: '/admin/outlets/delink',
        permissions: {
          action: 'delink',
          subjectClass: 'Outlet',
        }
      },
      {
        title: 'Levels',
        href: '/admin/levels',
        permissions: {
          action: 'read',
          subjectClass: 'Level',
        }
      }
    ]
  },
  {
    title: 'Groups',
    href: '/admin/groups',
    permissions: {
      action: 'handle',
      subjectClass: 'Group',
    }
  },
  {
    title: 'List submissions',
    href: '/admin/audit/submissions',
    permissions: {
      action: 'audit',
      subjectClass: 'Submission',
    }
  },
  {
    title: 'Notifications',
    children: [
      {
        title: 'Notifications',
        href: '/admin/notifications',
      },
      {
        title: 'Email Log',
        href: '/admin/email-logs',
        permissions: {
          action: 'index-email',
          subjectClass: 'Notification',
        },
      },
      {
        title: 'SMS Log',
        href: '/admin/sms-logs',
        permissions: {
          action: 'index-sms',
          subjectClass: 'Notification',
        },
      }
    ],
    permissions: {
      action: 'index',
      subjectClass: 'Notification',
    }
  },
  {
    title: 'Data management',
    permissions: {
      action: 'index',
      subjectClass: 'DataManagement',
    },
    children: [
      {
        title: 'Data import',
        href: '/admin/data-management',
        permissions: {
          action: 'import',
          subjectClass: 'data',
        }
      },
      {
        title: 'Data export',
        href: '/admin/data-export',
        permissions: {
          action: 'export',
          subjectClass: 'data',
        }
      }
    ]
  },
  {
    title: 'Pages',
    href: '/admin/pages',
    permissions: {
      action: 'index',
      subjectClass: 'Page',
    }
  },
  {
    title: 'Products',
    permissions: {
      action: 'read',
      subjectClass: 'product_related_subjects',
    },
    children: [
      {
        title: 'Categories',
        href: '/admin/categories',
        permissions: {
          action: 'index',
          subjectClass: 'Category',
        }
      },
      {
        title: 'Brands',
        href: '/admin/brands',
        permissions: {
          action: 'index',
          subjectClass: 'Brand',
        }
      },
      {
        title: 'Products',
        href: '/admin/products',
        permissions: {
          action: 'index',
          subjectClass: 'Product',
        }
      }
    ]
  },
  {
    title: 'Submissions',
    href: '/admin/submissions',
    permissions: {
      action: 'handle',
      subjectClass: 'Submission',
    }
  },
  {
    title: 'Inspect Submissions',
    href: '/admin/audit/submissions/next',
    permissions: {
      action: 'audit',
      subjectClass: 'Submission'
    }
  },
  {
    title: 'Scanning',
    permissions: {
      action: 'manage-scans',
      subjectClass: 'manage_scans',
    },
    children: [
      {
        title: 'Scans',
        href: '/admin/scans'
      },
      {
        title: 'Scan overrides',
        href: '/admin/scans/scan-overrides',
        permissions: {
          action: 'manage-scan-override-requests',
          subjectClass: 'ScanOverrideRequests'
        }
      },
      {
        title: 'Damaged barcode submissions',
        href: '/admin/scans/damaged-barcode-submissions',
        permissions: {
          action: 'manage-damaged-barcodes',
          subjectClass: 'DamagedBarcodes'
        }
      }
    ]
  },
  {
    title: 'Incentives',
    href: '/admin/incentives',
    permissions: {
      action: 'index',
      subjectClass: 'Incentive',
    }
  },
  {
    title: 'Rewards',
    href: '/admin/rewards',
    permissions: {
      action: 'index',
      subjectClass: 'StaffRewardSetting',
    },
    children: [
      {
        title: t('staffRewardSettings'),
        href: '/admin/staff-reward/settings',
        permissions: {
          action: 'manage',
          subjectClass: 'StaffRewardSetting',
        }
      },
      {
        title: t('staffRewards.redemption.menu'),
        href: '/admin/staff-reward/redemptions',
        permissions: {
          action: 'index',
          subjectClass: 'Redemption',
        }
      }
    ]
  },
  {
    title: 'Prepaid Cards',
    permissions: {
      action: 'index',
      subjectClass: 'PrepaidCards',
    },
    children: [
      {
        title: 'Prepaid Card Settings',
        href: '/admin/ppc/settings',
        permissions: {
          action: 'manage',
          subjectClass: 'PrepaidCardSetting',
        },
      },
      {
        title: 'Prepaid Card Management',
        href: '/admin/ppc/management',
        permissions: {
          action: 'index',
          subjectClass: 'PpcUser',
        },
      },
    ]
  },
  {
    title: 'Points',
    permissions: {
      action: 'index',
      subjectClass: 'ManagePoints',
    },
    children: [
      {
        title: 'Points types',
        href: '/admin/points-types',
        permissions: {
          action: 'index',
          subjectClass: 'ManagePoints',
        }
      },
      {
        title: 'Points transactions',
        href: '/admin/points-transactions',
        permissions: {
          action: 'index',
          subjectClass: 'PointTransaction',
        }
      },
      {
        title: 'Points expiry',
        href: '/admin/points-expiry',
        permissions: {
          action: 'manage',
          subjectClass: 'PointExpiry',
        }
      }
    ]
  },
  {
    title: 'Homepages',
    href: '/admin/homepages/retailers',
    permissions: {
      action: 'handle',
      subjectClass: 'home_page',
    }
  },
  {
    title: 'News',
    permissions: {
      action: 'index',
      subjectClass: 'new_categories_and_articles',
    },
    children: [
      {
        title: 'Categories',
        href: '/admin/news/categories',
        permissions: {
          action: 'index',
          subjectClass: 'new_categories_and_articles',
        }
      },
      {
        title: 'Articles',
        href: '/admin/news/articles',
        permissions: {
          action: 'index',
          subjectClass: 'new_categories_and_articles',
        }
      }
    ]
  },
  {
    title: 'App',
    permissions: {
      action: 'read',
      subjectClass: 'IosApp',
    },
    children: [
      {
        title: 'App settings',
        href: '/admin/app-settings'
      },
      {
        title: 'User access tokens',
        href: '/admin/user-access-tokens',
        permissions: {
          action: 'read',
          subjectClass: 'DeviceToken',
        }
      },
      {
        title: 'Push notification settings',
        href: '/admin/push-notification-templates',
        permissions: {
          action: 'read',
          subjectClass: 'PushNotificationTemplate',
        }
      },
      {
        title: 'Push notifications',
        href: '/admin/push-notifications',
        permissions: {
          action: 'read',
          subjectClass: 'PushNotification',
        }
      }
    ]
  },
  {
    title: 'Downloads',
    href: '/admin/downloads',
    permissions: {
      action: 'manage',
      subjectClass: 'downloads'
    }
  },
  {
    title: 'Objectives',
    permissions: {
      action: 'manage',
      subjectClass: 'objectives'
    },
    children: [
      {
        title: 'STOCK IT',
        href: '/admin/objectives/stock-it',
        permissions: {
          action: 'manage',
          subjectClass: 'StockIt',
        }
      },
      {
        title: 'PRICE IT',
        href: '/admin/objectives/price-it',
        permissions: {
          action: 'manage',
          subjectClass: 'PriceIt',
        }
      },
      {
        title: 'DISPLAY IT',
        href: '/admin/objectives/display-it',
        permissions: {
          action: 'manage',
          subjectClass: 'DisplayIt',
        }
      },
      {
        title: 'POSTCODE PLANS',
        href: '/admin/objectives/postcode-plans',
        permissions: {
          action: 'manage',
          subjectClass: 'PostcodePlan',
        }
      }
    ]
  },
  {
    title: 'Navigation',
    permissions: {
      action: 'handle',
      subjectClass: 'navigation'
    },
    children: [
      {
        title: 'Background',
        href: '/admin/navigation/background',
        permissions: {
          action: 'modify',
          subjectClass: 'NavigationImage'
        }
      },
      {
        title: 'Links',
        href: '/admin/navigation/links',
        permissions: {
          action: 'handle',
          subjectClass: 'navigation'
        }
      }
    ]
  },
  {
    title: 'Feature Toggles',
    href: '/admin/feature-toggles',
    permissions: {
      action: 'manage',
      subjectClass: 'FeatureToggles',
    }
  },
];

export const tradeSiteNavBarLinksAdmin = [
  {
    title: 'Users',
    permissions: {
      action: 'manage',
      subjectClass: 'users',
    },
    children: [
      {
        title: 'User Groups',
        href: '/admin/user-groups',
        permissions: {
          action: 'index',
          subjectClass: 'UserGroup',
        }
      },
      {
        title: 'Users',
        href: '/admin/users',
        permissions: {
          action: 'index',
          subjectClass: 'User',
        }
      },
      {
        title: 'Marketing Consent',
        href: '/admin/marketing-consent',
        permissions: {
          action: 'index',
          subjectClass: 'User',
        }
      }
    ]
  },
  ...navBarLinksAdmin
];

navBarLinksAdmin.unshift((tradeSiteEnabled() ? {
  title: 'Users',
  permissions: {
    action: 'manage',
    subjectClass: 'users',
  },
  children: [
    {
      title: 'User Groups',
      href: '/admin/user-groups',
      permissions: {
        action: 'index',
        subjectClass: 'UserGroup',
      }
    },
    {
      title: 'Users',
      href: '/admin/users',
      permissions: {
        action: 'index',
        subjectClass: 'User',
      }
    },
    {
      title: 'Marketing Consent',
      href: '/admin/marketing-consent',
      permissions: {
        action: 'manage',
        subjectClass: 'MarketingConsent',
      }
    }
  ]
} :
  {
    title: 'Users',
    permissions: {
      action: 'manage',
      subjectClass: 'users',
    },
    children: [
      {
        title: 'User Groups',
        href: '/admin/user-groups',
        permissions: {
          action: 'index',
          subjectClass: 'UserGroup',
        }
      },
      {
        title: 'Users',
        href: '/admin/users',
        permissions: {
          action: 'index',
          subjectClass: 'User',
        }
      }
    ]
  }));



// WEBPACK FOOTER //
// ./src/data/navbarLinks.js